import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-delete-confirmation',
    templateUrl: './delete-confirmation.component.html',
    styleUrls: ['./delete-confirmation.component.scss']
})
export class DeleteConfirmationComponent implements OnInit {

    public deleteText;
    public title;
    constructor(private dialogRef: MatDialogRef<DeleteConfirmationComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.deleteText = 'MODAL.DELETE_CONFIRM.SURE';
        this.title = 'MODAL.DELETE_CONFIRM.CONFIRM';
        if (this.data && Object.keys(this.data)?.length > 0) {
            this.deleteText = data?.text;
            this.title = data?.title;
        } else {
            this.deleteText = 'MODAL.DELETE_CONFIRM.SURE';
        }
    }

    ngOnInit() {
    }

    cancel() {
        this.dialogRef.close({ type: 'cancel' });
    }

    confirm() {
        this.dialogRef.close({ type: 'confirm' });
    }
}
